import { render, staticRenderFns } from "./ChatTime.vue?vue&type=template&id=09aaa66b"
import script from "./ChatTime.vue?vue&type=script&lang=js"
export * from "./ChatTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports